import { createAsyncThunk } from "@reduxjs/toolkit";

import { 
  getAllCategories as getAllCategoriesApi,
 } from "../../helpers/custom_helper/backend_helper";


 export const getAllCategoriesThunk = createAsyncThunk("get-all-categories", async () => {
  try {
   
     const response = getAllCategoriesApi();
    const data = await response;
  
    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});













